module.exports = __webpack_public_path__ + "img/work2-1.e71a1c62.png";